export const baseUrl = '/.netlify/functions/server/';